module.exports = new __parcel__URL__("gallery_8.70c829ad.jpg").toString();